const conditionGraphModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl:
    '/modules/modals/condition-graph-modal/condition-graph-modal.html',
  controller: 'ConditionGraphModalController',
};

angular
  .module('modalDirectives')
  .component('conditionGraphModal', conditionGraphModal);
